import { createContext } from "react";
import { io, Socket } from 'socket.io-client';
import { v4 as uuidv4 } from 'uuid';
import { ZIPTEAMS_API_BASE_URL } from "../utils/constants";

const APIURL = ZIPTEAMS_API_BASE_URL && ZIPTEAMS_API_BASE_URL.substring(ZIPTEAMS_API_BASE_URL.length - 4, 0)

export const socket = () => io(APIURL || '' , { transports: ["websocket"], auth: { user_id: uuidv4()} });
export const SocketContext = createContext<() => Socket>(socket);